var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E8EBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5H17.5M9.5 12H17.5M9.5 15.5H17.5M6.5 8.5H6.505V8.505H6.5V8.5ZM6.75 8.5C6.75 8.63807 6.63807 8.75 6.5 8.75C6.36193 8.75 6.25 8.63807 6.25 8.5C6.25 8.36193 6.36193 8.25 6.5 8.25C6.63807 8.25 6.75 8.36193 6.75 8.5ZM6.5 12H6.505V12.005H6.5V12ZM6.75 12C6.75 12.1381 6.63807 12.25 6.5 12.25C6.36193 12.25 6.25 12.1381 6.25 12C6.25 11.8619 6.36193 11.75 6.5 11.75C6.63807 11.75 6.75 11.8619 6.75 12ZM6.5 15.5H6.505V15.505H6.5V15.5ZM6.75 15.5C6.75 15.6381 6.63807 15.75 6.5 15.75C6.36193 15.75 6.25 15.6381 6.25 15.5C6.25 15.3619 6.36193 15.25 6.5 15.25C6.63807 15.25 6.75 15.3619 6.75 15.5Z",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponDetails);
export default __webpack_public_path__ + "static/media/coupon-details.4672dbe409c104beb1189db752419251.svg";
export { ForwardRef as ReactComponent };